export class Time {
  public readonly days: number = 0
  public readonly hours: number = 0
  public readonly minutes: number = 0
  public readonly seconds: number = 0

  constructor({
    days,
    hours,
    minutes,
    seconds,
  }: {
    days?: number
    hours?: number
    minutes?: number
    seconds?: number
  } = {}) {
    if (days) {
      this.days = days
    }
    if (hours) {
      this.hours = hours
    }
    if (minutes) {
      this.minutes = minutes
    }
    if (seconds) {
      this.seconds = seconds
    }
  }

  get totalSeconds() {
    return (
      this.days * 24 * 3600 +
      this.hours * 3600 +
      this.minutes * 60 +
      this.seconds
    )
  }

  get totalMilliseconds() {
    return this.totalSeconds * 1000
  }
}
